<template>
<div class="form-part">
  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-4 label-left">
          <b-form-checkbox v-model="fields.luci_extended_imagetyp_sel" class="mt-1">Image Type</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.luci_extended_imagetyp" class="fit-width">
            <option :value="null">Select...</option>
            <option>SCIENCE</option>
            <option>CALIBRATION</option>
            <option>DARK</option>
            <!--<option>FOCUS</option>-->
            <option>SKY FLAT</option>
            <option>IMAGING FLAT</option>
            <option>SLIT FLAT</option>
            <option>ARCS</option>
          </b-form-select>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_telescope_sel" class="mt-1">Telescope</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.luci_telescope" class="fit-width">
            <option :value="null">Select...</option>
            <option>LBT-DX</option>
            <option>LBT-SX</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6 label-left">
          <b-form-checkbox v-model="fields.luci_instrument_sel" class="mt-1 ml-4">Instrument</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-select v-model="fields.luci_instrument" class="fit-width">
            <option :value="null">Select...</option>
            <option>LUCI1</option>
            <option>LUCI2</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col"></div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_camera_sel" class="mt-1">Camera</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.luci_camera" class="fit-width">
            <option :value="null">Select...</option>
            <option>N3.75 Camera</option>
            <option>N1.8 Camera</option>
            <option>N30 Camera</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6 label-left">
          <b-form-checkbox v-model="fields.luci_gratname_sel" class="mt-1 ml-4">Grat. Name</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-select v-model="fields.luci_gratname" class="fit-width">
            <option :value="null">Select...</option>
            <option value="mirror">Mirror</option>
            <option>G210 HiRes</option>
            <option>G200 LoRes</option>
            <option>G150 Ks</option>
            <option>G040 AO</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 label-left" title="Calibration unit">
          <b-form-checkbox v-model="fields.luci_calib_sel" class="mt-1 ml-4">Calib</b-form-checkbox>
        </div>
        <div class="col-6 radio-toolbar">
          <input type="radio" id="luci_calib_null" :value="null" name="luci_calib" v-model="fields.luci_calib" />
          <label for="luci_calib_null">N/A</label>
          <input type="radio" id="luci_calib_in" value="1" name="luci_calib" v-model="fields.luci_calib" />
          <label for="luci_calib_in">IN</label>
          <input type="radio" id="luci_calib_out" value="0" name="luci_calib" v-model="fields.luci_calib" />
          <label for="luci_calib_out">OUT</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_filter1_sel" class="mt-1">Filter 1</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.luci_filter1" class="fit-width">
            <option :value="null">Select...</option>
            <option>clear</option>
            <option>blind</option>
            <option>Y1</option>
            <option>Y2</option>
            <option>OH_1060</option>
            <option>OH_1190</option>
            <option>HeI</option>
            <option>P_gam</option>
            <option>P_beta</option>
            <option>J_low</option>
            <option>J_high</option>
            <option>FeII</option>
            <option>H2</option>
            <option>Br_gam</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6 label-left" id="gratwlen_sel">
          <b-form-checkbox v-model="fields.luci_gratwlen_sel" class="mt-1 ml-4">Grat. Wavelen.</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-input v-model="fields.luci_gratwlen" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_lamp1_sel" class="mt-1 ml-4">Lamp Ne</b-form-checkbox>
        </div>
        <div class="col-7 radio-toolbar">
          <input type="radio" id="luci_lamp1_null" :value="null" name="luci_lamp1" v-model="fields.luci_lamp1" />
          <label for="luci_lamp1_null">N/A</label>
          <input type="radio" id="luci_lamp1_on" value="1" name="luci_lamp1" v-model="fields.luci_lamp1" />
          <label for="luci_lamp1_on">ON</label>
          <input type="radio" id="luci_lamp1_off" value="0" name="luci_lamp1" v-model="fields.luci_lamp1" />
          <label for="luci_lamp1_off">OFF</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_filter2_sel" class="mt-1">Filter 2</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.luci_filter2" class="fit-width">
            <option :value="null">Select...</option>
            <option>clear</option>
            <option>blind</option>
            <option>z</option>
            <option>J</option>
            <option>H</option>
            <option>K</option>
            <option>Ks</option>
            <option>zJspec</option>
            <option>HKspec</option>
          </b-form-select>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6 label-left">
          <b-form-checkbox v-model="fields.luci_gratvolt_sel" class="mt-1 ml-4">Grat. Volt</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-input v-model="fields.luci_gratvolt" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_lamp2_sel" class="mt-1 ml-4">Lamp Ar</b-form-checkbox>
        </div>
        <div class="col-7 radio-toolbar">
          <input type="radio" id="luci_lamp2_null" :value="null" name="luci_lamp2" v-model="fields.luci_lamp2" />
          <label for="luci_lamp2_null">N/A</label>
          <input type="radio" id="luci_lamp2_on" value="1" name="luci_lamp2" v-model="fields.luci_lamp2" />
          <label for="luci_lamp2_on">ON</label>
          <input type="radio" id="luci_lamp2_off" value="0" name="luci_lamp2" v-model="fields.luci_lamp2" />
          <label for="luci_lamp2_off">OFF</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_maskslot_sel" class="mt-1">Mask N.</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-input v-model="fields.luci_maskslot" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <div class="col-6 label-left">
          <b-form-checkbox v-model="fields.luci_gratorde_sel" class="mt-1 ml-4">Grat. Order</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-input v-model="fields.luci_gratorde" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_lamp3_sel" class="mt-1 ml-4">Lamp Xe</b-form-checkbox>
        </div>
        <div class="col-7 radio-toolbar">
          <input type="radio" id="luci_lamp3_null" :value="null" name="luci_lamp3" v-model="fields.luci_lamp3" />
          <label for="luci_lamp3_null">N/A</label>
          <input type="radio" id="luci_lamp3_on" value="1" name="luci_lamp3" v-model="fields.luci_lamp3" />
          <label for="luci_lamp3_on">ON</label>
          <input type="radio" id="luci_lamp3_off" value="0" name="luci_lamp3" v-model="fields.luci_lamp3" />
          <label for="luci_lamp3_off">OFF</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row mt-3">
        <div class="col-4">
          <label class="label-right">Mask type</label>
        </div>
        <div class="col-8">
          <b-form-radio-group v-model="fields.luci_masktype">
            <b-form-radio name="luci_masktype" value="standard" @change="luciMaskTypeChanged">Standard</b-form-radio>
            <b-form-radio name="luci_masktype" value="custom" @change="luciMaskTypeChanged">Custom</b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6 label-left">
          <b-form-checkbox v-model="fields.luci_optic_sel" class="mt-1 ml-4">Optic</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-input v-model="fields.luci_optic" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_lamp4_sel" class="mt-1 ml-4">Halo 1</b-form-checkbox>
        </div>
        <div class="col-7 radio-toolbar">
          <input type="radio" id="luci_lamp4_null" :value="null" name="luci_lamp4" v-model="fields.luci_lamp4" />
          <label for="luci_lamp4_null">N/A</label>
          <input type="radio" id="luci_lamp4_on" value="1" name="luci_lamp4" v-model="fields.luci_lamp4" />
          <label for="luci_lamp4_on">ON</label>
          <input type="radio" id="luci_lamp4_off" value="0" name="luci_lamp4" v-model="fields.luci_lamp4" />
          <label for="luci_lamp4_off">OFF</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_mask_sel" class="mt-1">Mask</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-select v-model="fields.luci_mask" class="fit-width" v-if="fields.luci_masktype === 'standard'">
            <option :value="null">Select...</option>
            <option>blind</option>
            <option>LS_0.25arcsec</option><!-- _150um -->
            <option>LS_0.50arcsec</option><!-- _300um -->
            <option>LS_0.75arcsec</option><!-- _450um -->
            <option>LS_1.00arcsec</option><!-- _600um -->
            <option>LS_1.50arcsec</option><!-- _900um -->
            <option>LS_2.00arcsec</option><!-- _1200um -->
            <option>LS_2.0_1.5arcsec</option>
            <option>N30_FieldStop</option>
            <option>N30LS_0.13arcsec</option>
            <option>Pixelflat_30</option>
            <!--<option>OptiSpec_Sieve</option>-->
            <!-- engineerig testing only -->
          </b-form-select>
          <b-form-input v-model="fields.luci_mask" class="fit-width" v-if="fields.luci_masktype === 'custom'" placeholder="Custom name"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6 label-left">
          <b-form-checkbox v-model="fields.luci_mospos_sel" class="mt-1 ml-4">MOS Position</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-input v-model="fields.luci_mospos" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_lamp5_sel" class="mt-1 ml-4">Halo 2</b-form-checkbox>
        </div>
        <div class="col-7 radio-toolbar">
          <input type="radio" id="luci_lamp5_null" :value="null" name="luci_lamp5" v-model="fields.luci_lamp5" />
          <label for="luci_lamp5_null">N/A</label>
          <input type="radio" id="luci_lamp5_on" value="1" name="luci_lamp5" v-model="fields.luci_lamp5" />
          <label for="luci_lamp5_on">ON</label>
          <input type="radio" id="luci_lamp5_off" value="0" name="luci_lamp5" v-model="fields.luci_lamp5" />
          <label for="luci_lamp5_off">OFF</label>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_aostatus_sel" class="mt-1">AO status</b-form-checkbox>
        </div>
        <div class="col-7">
          <b-form-input v-model="fields.luci_aostatus" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6 label-left">
          <b-form-checkbox v-model="fields.luci_aonmodes_sel" class="mt-1 ml-4">AO modes</b-form-checkbox>
        </div>
        <div class="col-6">
          <b-form-input v-model="fields.luci_aonmodes" class="fit-width"></b-form-input>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-5 label-left">
          <b-form-checkbox v-model="fields.luci_lamp6_sel" class="mt-1 ml-4">Halo 3</b-form-checkbox>
        </div>
        <div class="col-7 radio-toolbar">
          <input type="radio" id="luci_lamp6_null" :value="null" name="luci_lamp6" v-model="fields.luci_lamp6" />
          <label for="luci_lamp6_null">N/A</label>
          <input type="radio" id="luci_lamp6_on" value="1" name="luci_lamp6" v-model="fields.luci_lamp6" />
          <label for="luci_lamp6_on">ON</label>
          <input type="radio" id="luci_lamp6_off" value="0" name="luci_lamp6" v-model="fields.luci_lamp6" />
          <label for="luci_lamp6_off">OFF</label>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'Lucifer',
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors
  }),
  methods: {
    luciMaskTypeChanged() {
      this.fields.luci_mask = null;
    }
  }
}
</script>

<style>
#gratwlen_sel {
  padding-right: 0;
}
</style>
